import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { GlobalsService } from '../../services/globals';

@Component({
  selector: 'app-combo-box-loading',
  templateUrl: './combo-box-loading.component.html',
  styleUrls: ['./combo-box-loading.component.scss']
})
export class ComboBoxLoadingComponent implements OnInit, OnChanges {

    @Input() id: string = null;
    @Input() listData: any = [];
    @Input() indice: string;
    @Input() selectData: any = null;
    @Input() fondo: boolean;
    @Input() update: boolean;
    @Input() widthSelect = true;
    @Input() heightSelect = false;
    @Input() search = false;
    @Input() modulo = '';
    @Input() isDropup = false;
    @Input() error: boolean;
    @Input() preloaded: string = null;
    @Output() selectId = new EventEmitter();
    @Output() change = new EventEmitter();
    @Output() clickData = new EventEmitter();

    valueText: string = '';
    value = 0;
    textSearch = '';
    etiqueta: any;
    loadText: string;
    load = true;

    constructor(private globals: GlobalsService) {
    }

    ngOnInit() {
        this.getTranslate();
    }

    ngOnChanges() {
        if (this.listData !== null) {
            this.heightSelect = (this.listData.length > 8) ? true : false;
        } else {
            this.heightSelect = false;
        }
        this.updateSelect();
        // console.log(this.preloaded)
        if (this.preloaded) {
            this.valueText = this.preloaded
        }
    }

    selectItem(data = null) {
        if (data) {
            if (this.indice[0].indexOf('.') > -1) {
                const index = this.indice[0].split('.');
                const index2 = this.indice[1].split('.');

                this.valueText = data[index2[0]][index2[1]];
                this.value = data[index[0]][index[1]];
            } else {
                this.valueText = data[this.indice[1]];
                this.value = data[this.indice[0]];
            }
        } else {
            this.valueText = this.etiqueta.select;
            this.value = 0;
        }

        this.selectId.emit(this.value);
        this.change.emit(false);
        this.clickData.emit(data);
        this.textSearch = '';
    }

    viewList(data) {
        if (this.indice[1].indexOf('.') > -1) {
            const index = this.indice[1].split('.');
            return data[index[0]][index[1]];
        } else {
            return data[this.indice[1]];
        }
    }

    updateSelect() {
        // console.log(this.listData)
        if (this.selectData && this.update) {
            if (this.indice[0].indexOf('.') > -1) {
                const index = this.indice[0].split('.');
                const index2 = this.indice[1].split('.');
                this.listData.map((element: any) => {
                    if (element[index[0]][index[1]] === this.selectData) {
                        this.valueText = element[index2[0]][index2[1]];
                        this.value = element[index[0]][index[1]];
                    }
                });
                // for (const key in this.listNorma) {
                //     if (this.listNorma[key].id === moduloId) {
                //         data = this.listNorma[key];
                //     }
                // }
        
            } else {
                this.listData.map((element: any) => {
                    if (element[this.indice[0]] === this.selectData) {
                        this.valueText = element[this.indice[1]];
                        this.value = element[0];
                    }
                });
            }
        }
    }

    clickInput(event) {
        event.stopPropagation();
    }

    async getTranslate() {
        await this.globals.getTranslate('globals').subscribe((resp: any) => {
            this.etiqueta = resp;
            this.loadText = this.etiqueta.load;
            this.valueText = this.etiqueta.select;
        });
    }
}
